import jsxElem, { render } from "jsx-no-react";
import { modalContainer, modalClose } from "@Utils";

const BASE_BUILDER_MEDIA_URL = process.env.MIX_PERXI_MEDIA;

const isURL = (str) => {
    let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    return regexp.test(str);
};

const isEmail = (email) => String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

const SMTPValidator = (frm) => {
    let errorCount = 0;
    $(`#${frm} .required`).each(function () {
        
        if(!$(this).val().length) {
            errorCount++; 
            $(this).addClass("error");
        } else {

            if($(this).hasClass('email')) {
                if(!isEmail($(this).val())){
                    errorCount++; 
                    $(this).addClass("error");
                } else {
                    $(this).removeClass("error");
                }
            }  else {
                $(this).removeClass("error");
            } 

        }

    });

    return errorCount ? false : true;
};

const validateImage = (e)  => {
    let response = false;
    e = e.target;
  
    if (e.files && e.files[0]) {
      let name = e.files[0].name, 
      ext = name.split('.').pop().toLowerCase(),
      exts = ['png', 'jpg', 'gif', 'jpeg'];
      response = exts.includes(ext);
    }
   
    if(!response) {
        render( <ModalError title="Unsupported Image Format" message="Please upload a .png, .jpg, .jpeg or .gif image for email compatibility." />, modalContainer);
        return false;
    }

    return response;
};

const validateImageAdvanced= (e) => {
    let valid = false;
    let response = {};

    e = e.target;

    if (e.files && e.files[0]) {
        let name = e.files[0].name, 
        ext = name.split('.').pop().toLowerCase(),
        exts = ['png', 'jpg', 'gif', 'jpeg'];
        
        valid = exts.includes(ext);

        response = {
            extension: ext,
            isValid: valid
        };
    }

    if (!valid) {
        render( <ModalError title="Unsupported Image Format" message="Please upload a .png, .jpg, .jpeg or .gif image for email compatibility." />, modalContainer);
        return response;
    }

    return response;
};

const ResetError = () => {
    $(document).on('keyup', '.error',  function(e) {
        if($(this).val() != '') $(this).removeClass("error");
    });
};


const builderImage = (url, tag = false, text = "") => {
    if(tag == true) {
        return `<img src="${BASE_BUILDER_MEDIA_URL}/${url}" /> ${text}`;
    }

    return `${BASE_BUILDER_MEDIA_URL}/${url}`;
};

const destructureShorthandCSS = function (arr) {
	let top = 0,
		right = 0,
		bottom = 0,
		left = 0;

	switch (arr.length) {
		case 1:
			[top] = arr;
			right = bottom = left = top;
			break;
		case 2:
			[top, right] = arr;
			bottom = top;
			left = right;
			break;
		case 3:
			[top, right, bottom] = arr;
			left = right;
			break;
		case 4:
			[top, right, bottom, left] = arr;
			break;
		default:
			throw new Error('Invalid TRBL');
	}

	return [parseFloat(top), parseFloat(right), parseFloat(bottom), parseFloat(left)];
};


const bmTippy = () => tippy('.bmux-tippy[title]', {
    delay: 5, 
    maxWidth: 300, 
    interactive: true,
    allowHTML: true,
    theme: 'custom',
    arrow: true,
    animation: 'fade',
    ignoreAttributes: true,
    content(reference) {
        const title = reference.getAttribute('title');
        reference.removeAttribute('title');
        return title;
    },
});


const ModalError =(props) => (
    <>
        <div class="modal fade" style="display:block; opacity:1">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-danger">{props.title}</h5>
                    </div>
                    <div class="modal-body p-3"> 
                        <p>{props.message}</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" onClick={modalClose} >OK</button>
                    </div>                        
                </div>
            </div>
        </div> 
        <div class="modal-backdrop fade show"></div>
    </>
);

const renderFraudAlertLevel = (props) => {
    const {risk, refs, views} = props.data;
    if(refs > views || risk > 50) return "<span class='fa fa-circle text-danger small cursor' data-tippy-content='High Risk'></span>";
    if(risk > 5 && risk <= 50) return "<span class='fa fa-circle text-warning small cursor' data-tippy-content='Medium Risk'></span>";
    if(risk > 0 && risk <= 5) return "<span class='fa fa-circle text-success small cursor' data-tippy-content='Low Risk'></span>";
    return "<span class='fa fa-circle bmui-fa-circle-hollow small cursor' data-tippy-content='No Risk'></span>"
};

const renderUserSource = (props) => {
    let t = '';
    if(props.via != undefined) {
        switch(props.via) {
            case 'W': t += '<span class="fas fa-globe text-primary" data-tippy-content="Website"></span>';
                break;
            case 'A': t += '<span class="fas fa-code text-danger" data-tippy-content="API"></span>';
                break;
            case 'O': t += '<span class="fas fa-link text-warning" data-tippy-content="Opt-in Link"></span>';
                break;
        }
    }

    if(props.referrer != undefined) {
        // for sake of filter referred by. Hide it.
        t += ` <span class="d-none">${ props.referrer}</span><span class="fas fa-bullhorn text-info" data-tippy-content="Referred by: ${ props.referrer}"></span>`;
    }
    
    return t;
};

const StyledInteractiveNumber = (props) => props.number == 0 ? props.number : `<strong>${props.number}</strong>`;


const renderDevices = (device) => {
    const icons = {
        unknown: "<span class='fa fa-question' data-tippy-content='Unknown Device Detected'></span>",
        desktop: "<span class='fa fa-desktop text-info' data-tippy-content='Desktop'></span>",
        mobile: "<span class='fa fa-mobile text-info' data-tippy-content='Mobile'></span>",
        api: "<span class='fa fa-code text-info' data-tippy-content='API'></span>"
    };

    return icons[device] || icons.unknown;
};

const renderTags = (props) => {
    if(!props.data || !props.data.length) return '';
    return props.data.map(tag => `<span class="fa fa-bolt tag-${tag} me-1" data-tippy-content='${tag}'></span>`).join(' ');
};

export { 
    isURL,
    isEmail,
    SMTPValidator,
    ResetError,
    destructureShorthandCSS,
    builderImage,
    validateImage,
    validateImageAdvanced,
    bmTippy,
    ModalError,
    renderFraudAlertLevel,
    StyledInteractiveNumber,
    renderUserSource,
    renderDevices,
    renderTags
};